import { CategoryViewAll } from '@/app/elements/category-view-all';
import type { RotatingTitles } from '@/types/zones/zone';
import { RotatingZoneTitle } from './rotating-zone-title.client';

import './styles/@theme';

type ZoneHeaderProps = {
    title?: string;
    subtitle?: string;
    categoryUid?: string;
    rotatingTitles?: RotatingTitles;
    zoneUid?: string;
};

export const ZoneHeader = ({ title, subtitle, categoryUid, rotatingTitles, zoneUid }: ZoneHeaderProps) => {
    const rotatingTitleList =
        rotatingTitles?.enabled && rotatingTitles.titles.length > 1 ? rotatingTitles.titles : null;

    return (
        title && (
            <div data-testid="zone-header" className="zone__header">
                <div className="zone__header__title">
                    <h2>
                        {rotatingTitleList ? <RotatingZoneTitle titles={rotatingTitleList} zoneKey={zoneUid} /> : title}
                    </h2>
                    {categoryUid && <CategoryViewAll categoryUid={categoryUid} zoneName={title} />}
                    {/* TODO: subtitle for jackpots zone */}
                </div>
                {subtitle && <p data-testid="zone-header-subtitle">{subtitle}</p>}
            </div>
        )
    );
};
